import React, { InputHTMLAttributes } from 'react';
import $ from 'jquery';

export interface SelectData {
  id: number;
  name: string;
}
interface LabelImputProps {
  id: string;
  labelText: string;
  name: string;
  type: 'text' | 'password' | 'hidden' | 'select';
  inputDynparam?: InputHTMLAttributes<HTMLInputElement>;
  requied?: boolean;
  breakLine?: boolean;
  selectData?: { data: SelectData[]; selected: number };
  onBlur?: (event: any) => void;
  onChange?: (event: any) => void;
}

export default class LabelInput extends React.Component<LabelImputProps> {
  componentDidUpdate(prevProp: any, prevState: any) {
    if (
      this.props.inputDynparam != undefined &&
      this.props.inputDynparam.defaultValue !=
        prevProp.inputDynparam.defaultValue
    ) {
      let inputHtml = $('#' + this.props.id)[0];
      let newValue = this.props.inputDynparam.defaultValue;
      inputHtml.value = newValue;
    }
  }

  render() {
    let item: LabelImputProps = { ...this.props };

    if (item.breakLine == undefined) {
      item.breakLine = true;
    }

    if (item.inputDynparam == undefined || item.inputDynparam == null) {
      item.inputDynparam = {};
    }
    if (item.requied === true) item.inputDynparam.required = true;

    if (item.type == 'hidden') item.breakLine = false;
    if (item.type == 'text' && item.inputDynparam.defaultValue == null) {
      item.inputDynparam.defaultValue = '';
    }

    return (
      <>
        {item.type != 'hidden' ? (
          <label className="inputLabel" htmlFor={item.id}>
            {item.requied ? (
              <b>
                {item.labelText}
                {':'}
                <span className="alert">*</span>
              </b>
            ) : (
              <>
                {item.labelText}
                {':'}
                {this.props.children}
              </>
            )}
          </label>
        ) : null}
        {item.type == 'select' ? (
          <select
            name={item.name}
            id={item.id}
            defaultValue={this.props.selectData?.selected}
            disabled={this.props.inputDynparam?.readOnly == true}
            onChange={(ev) => {
              let event: any = ev;
              if (this.props.inputDynparam?.onChange != undefined) {
                this.props.inputDynparam.onChange(event);
              }
            }}
          >
            {item.selectData?.data?.map((sd, index) => (
              <option value={sd.id} key={'select_' + index}>
                {sd.name}
              </option>
            ))}
          </select>
        ) : (
          <input
            type={item.type}
            name={item.name}
            id={item.id}
            {...item.inputDynparam}
            onBlur={(even) => {
              if (this.props.onBlur != undefined) this.props.onBlur(even);
            }}
            onChange={(even) => {
              if (this.props.onChange != undefined) this.props.onChange(even);
            }}
          />
        )}

        {item.breakLine ? <br className="clearBoth" /> : null}
      </>
    );
  }
}
